// extracted by mini-css-extract-plugin
module.exports =  {"overlay":"bEeBw2f","content":"fsedfov","mobile-full-screen":"P7Ffh3s","mobileFullScreen":"P7Ffh3s","container":"LmGSIS4","top-padding":"XY25rQP","topPadding":"XY25rQP"};